import { z } from 'zod';
/** How confidently a line on a $0 exchange order traced back to the line the customer paid for. */
export const LineTraceMatch = {
    exact: 'exact',
    ambiguous: 'ambiguous',
    unresolved: 'unresolved',
};
export const storeOrderLineItem = z.object({
    id: z.number(),
    exchangeLineItemIdFromPlatform: z.string().optional(),
    // the id of the line item on the platform
    idFromPlatform: z.string(),
    isCorsoProduct: z.boolean(),
    // the name on the storeOrderLineItem (typically refers to the product name including the variant options)
    productIdFromPlatform: z.string(),
    variantIdFromPlatform: z.string().nullable(), // ? ideally someday maybe this isn't nullable, for now this will work fine
    name: z.string().nullable(),
    optionsFromPlatform: z.array(z.object({ name: z.string(), value: z.string() })),
    // the quantity of the line item
    currentQuantity: z.number(),
    quantity: z.number(),
    // the ACTUAL price paid for a single quantity of the line item, inclusive of discounts
    // essentially represents the "unit" price of the line item for a single quantity
    unitPrice: z.number(),
    unitListPrice: z.number().optional(), // the price of the line item before any discounts were applied
    unitTax: z.number(), // the amount of tax paid for a single quantity of the line item
    /**
     * Only on a $0 line of an exchange order under claim lineage: how confidently `unitPrice` and
     * `unitTax` were traced back to the order the customer paid on. `exact` means they were replaced
     * with the paid values; anything else leaves the line at $0.
     */
    exchangeValueTrace: z.enum(LineTraceMatch).optional(),
    imgUrl: z.string().nullable(),
    fulfillmentServiceName: z.string().optional(),
    sku: z.string().optional(),
    grams: z.number(),
    barcode: z.string().optional(),
});
//# sourceMappingURL=lineItem.js.map